/* eslint-disable prettier/prettier */
export const NoticesIndexView = () => import(/* webpackChunkName: "notices-module" */ "@/views/notices/index.vue");